import { render, staticRenderFns } from "./ProductConfigCheckBoxGrid-gt3.vue?vue&type=template&id=422a462a&scoped=true"
import script from "./ProductConfigCheckBoxGrid-gt3.vue?vue&type=script&lang=js"
export * from "./ProductConfigCheckBoxGrid-gt3.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigCheckBoxGrid-gt3.vue?vue&type=style&index=0&id=422a462a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a462a",
  null
  
)

export default component.exports